import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";
import Alert from "@amzn/meridian/alert";
import { useSelector } from "react-redux";
import { keys } from "i18n";

/**
 * Accepts "lat, lng" or a place name (geocoded via HERE).
 */
export default function FindYardForm({ onLocate }) {
  const [query, setQuery] = useState("");
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const secrets = useSelector((state) => state.secrets);

  const handleGo = async () => {
    setError(null);
    const trimmed = query.trim();
    if (!trimmed) return;

    // Try parsing as "lat, lng"
    const coordMatch = trimmed.match(/^(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)$/);
    if (coordMatch) {
      const lat = parseFloat(coordMatch[1]);
      const lng = parseFloat(coordMatch[2]);
      if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        onLocate([lat, lng]);
        return;
      }
    }

    // Geocode via HERE
    try {
      const res = await fetch(
        `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(
          trimmed
        )}&limit=1&apiKey=${secrets.hereApiKey}`
      );
      const data = await res.json();
      if (data.items && data.items.length > 0) {
        const { lat, lng } = data.items[0].position;
        onLocate([lat, lng]);
      } else {
        setError(t(keys.LOCATION_NOT_FOUND));
      }
    } catch {
      setError(t(keys.GEOCODING_FAILED));
    }
  };

  return (
    <div>
      <Row spacing="small" widths={["fill", "fit"]}>
        <Input
          value={query}
          onChange={setQuery}
          placeholder={t(keys.ENTER_COORDINATES_OR_ADDRESS)}
          onKeyDown={(e) => e.key === "Enter" && handleGo()}
        />
        <Button type="primary" onClick={handleGo}>
          {t(keys.SEARCH)}
        </Button>
      </Row>
      {error && (
        <Alert type="error" size="small">
          {error}
        </Alert>
      )}
    </div>
  );
}
